var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img-tag",class:{ bg: _vm.bg },style:({ top: _vm.top, left: _vm.left, right: _vm.right, bottom: _vm.bottom, width: _vm.width, height: _vm.height }),attrs:{"src":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }